import { MarketingType, ObjectType, RawFilterConfigCriteria, RawFilterConfigObjectType } from '../ApiClientTypes';

export const filterConfig: RawFilterConfigObjectType = [
  {
    marketingType: MarketingType.BUY,
    objectType: ObjectType.FLAT,
    fields: [RawFilterConfigCriteria.PRICE, RawFilterConfigCriteria.LIVING_SPACE, RawFilterConfigCriteria.ROOMS],
  },
  {
    marketingType: MarketingType.BUY,
    objectType: ObjectType.HOUSE,
    fields: [RawFilterConfigCriteria.PRICE, RawFilterConfigCriteria.LIVING_SPACE, RawFilterConfigCriteria.ROOMS],
  },
  {
    marketingType: MarketingType.BUY,
    objectType: ObjectType.PROPERTY,
    fields: [RawFilterConfigCriteria.PRICE, RawFilterConfigCriteria.PROPERTY_SIZE],
  },
  {
    marketingType: MarketingType.BUY,
    objectType: ObjectType.OFFICE,
    fields: [RawFilterConfigCriteria.PRICE, RawFilterConfigCriteria.TOTAL_SPACE],
  },
  {
    marketingType: MarketingType.BUY,
    objectType: ObjectType.COMMERCE,
    fields: [RawFilterConfigCriteria.PRICE, RawFilterConfigCriteria.TOTAL_SPACE],
  },
  {
    marketingType: MarketingType.BUY,
    objectType: ObjectType.CATERING,
    fields: [RawFilterConfigCriteria.PRICE, RawFilterConfigCriteria.TOTAL_SPACE],
  },
  {
    marketingType: MarketingType.BUY,
    objectType: ObjectType.HALL,
    fields: [RawFilterConfigCriteria.PRICE, RawFilterConfigCriteria.TOTAL_SPACE],
  },
  {
    marketingType: MarketingType.BUY,
    objectType: ObjectType.OTHERS,
    fields: [RawFilterConfigCriteria.PRICE],
  },
  {
    marketingType: MarketingType.BUY,
    objectType: ObjectType.INTEREST,
    fields: [RawFilterConfigCriteria.PRICE],
  },
  {
    marketingType: MarketingType.RENT,
    objectType: ObjectType.FLAT,
    fields: [RawFilterConfigCriteria.RENT, RawFilterConfigCriteria.LIVING_SPACE, RawFilterConfigCriteria.ROOMS],
  },
  {
    marketingType: MarketingType.RENT,
    objectType: ObjectType.HOUSE,
    fields: [RawFilterConfigCriteria.RENT, RawFilterConfigCriteria.LIVING_SPACE, RawFilterConfigCriteria.ROOMS],
  },
  {
    marketingType: MarketingType.RENT,
    objectType: ObjectType.PROPERTY,
    fields: [RawFilterConfigCriteria.LEASE, RawFilterConfigCriteria.PROPERTY_SIZE],
  },
  {
    marketingType: MarketingType.RENT,
    objectType: ObjectType.OFFICE,
    fields: [RawFilterConfigCriteria.RENT, RawFilterConfigCriteria.TOTAL_SPACE],
  },
  {
    marketingType: MarketingType.RENT,
    objectType: ObjectType.COMMERCE,
    fields: [RawFilterConfigCriteria.RENT, RawFilterConfigCriteria.TOTAL_SPACE],
  },
  {
    marketingType: MarketingType.RENT,
    objectType: ObjectType.CATERING,
    fields: [RawFilterConfigCriteria.RENT, RawFilterConfigCriteria.TOTAL_SPACE],
  },
  {
    marketingType: MarketingType.RENT,
    objectType: ObjectType.HALL,
    fields: [RawFilterConfigCriteria.RENT, RawFilterConfigCriteria.TOTAL_SPACE],
  },
  {
    marketingType: MarketingType.RENT,
    objectType: ObjectType.OTHERS,
    fields: [RawFilterConfigCriteria.RENT],
  },
];
